import { Alert, Card, ClickAwayListener, Modal, Snackbar } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useAlert from "../../hooks/useAlert";
import useSocialConnection from "../../hooks/useSocialConnection";
import { TaskStateType } from "../../types/types";
import { getProticoClient } from "../../utils/api";
import { ButtonGroup, CancelButton, SaveButton } from "./BlockUserModal.styles";
import { useWeb3Auth } from "../../hooks/useWeb3Auth";

const DeketeUserPage = ({
  open,
  onClosePage,
  address,
  callback,
}: {
  open: any;
  onClosePage: any;
  address: string;
  callback?: any;
}) => {
  const { t } = useTranslation();
  const [isFetching, setIsFetching] = useState(false);
  const { refetch: renewUserSocialConnection } = useSocialConnection();
  const { address: userAddress } = useWeb3Auth();
  const [isOpen, alertContent, isError, setOptionalAlertContent] = useAlert();

  const onDeleteUser = async () => {
    setIsFetching(true);
    try {
      await getProticoClient().contact.deleteOne(address);
      const newConnections = await getProticoClient().contact.get(userAddress);
      renewUserSocialConnection(
        newConnections.filter((c) => c.target !== address)
      );
      if (callback) callback();
    } catch (e) {
      // Update SocialConnections failed
      setIsFetching(false);
      setOptionalAlertContent(
        t("FlashChat_Profile_Failed"),
        TaskStateType.FAIL
      );
      return;
    }
    setIsFetching(false);
    onClosePage();
    // Delete connection/invitation successfully
  };

  return (
    <React.Fragment>
      <Modal
        hideBackdrop={false}
        open={open}
        onClose={onClosePage}
        aria-labelledby="child-modal-title"
      >
        <div>
          <Snackbar
            open={isOpen}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert variant="filled" severity="error" color="error">
              <strong>{alertContent}</strong>
            </Alert>
          </Snackbar>
          <ClickAwayListener
            onClickAway={() => {
              onClosePage();
            }}
          >
            <Card
              style={{
                display: "flex",
                background: "#111",
                border: "1px solid #333",
                width: "70%",
                maxWidth: "20rem",
                height: "10rem",
                marginTop: "1rem",
                padding: "1.5rem",
                flexGrow: 1,
                flexDirection: "column",
                position: "absolute" as "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                alignItems: "center",
                justifyContent: "space-around",
              }}
            >
              <h3
                style={{
                  textAlign: "center",
                  color: "#ddd",
                  marginBottom: "25px",
                }}
              >
                {t("FlashChat_Profile_Delete_Confirm")}
              </h3>
              <ButtonGroup>
                <SaveButton
                  onClick={() => {
                    onDeleteUser();
                  }}
                  loading={isFetching}
                >
                  {t("FlashChat_Profile_Confirm")}
                </SaveButton>
                <CancelButton
                  onClick={() => {
                    onClosePage();
                  }}
                >
                  {t("FlashChat_Profile_Cancel")}
                </CancelButton>
              </ButtonGroup>
            </Card>
          </ClickAwayListener>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default DeketeUserPage;
